import * as types from '../actions/_actionTypes';
import initialState from './_initialReducerState'

export default function BudgetlineReducer(state = initialState.budgetlineContent, action: any) {
  switch (action.type) {
    case types.SAVE_BUDGETLINECONTENT_SUCCESS:
      return action.budgetlineContent;
    default:
      return state;
  }
}
